import { CalculationFunctionValuesEnum } from 'entities/mechanic/model';

export const useMechanicCreateRowDisabledRule = (
  rowCount: number,
  editableRow: number | null,
  calculationFunction: CalculationFunctionValuesEnum,
  isCycle: boolean,
) => {
  switch (calculationFunction) {
    case CalculationFunctionValuesEnum.CF3:
      return editableRow !== null || rowCount === 1;
    case CalculationFunctionValuesEnum.CF1:
      return editableRow !== null || (isCycle && rowCount === 1);
    case CalculationFunctionValuesEnum.CF2:
      return editableRow !== null || (isCycle && rowCount === 1);
    case CalculationFunctionValuesEnum.CF4:
      return editableRow !== null || (isCycle && rowCount === 1);
    default:
      return editableRow !== null;
  }
};
